import { render, staticRenderFns } from "./DataListSettings.vue?vue&type=template&id=4831f632"
import script from "./DataListSettings.vue?vue&type=script&lang=js"
export * from "./DataListSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports